module.exports = __webpack_public_path__ + "static/img/yiti_01.4b7df617.jpg";